import SidebarContainer from 'src/components/Sidebar/SidebarContainer';

export default SidebarContainer;
